import { Validator, isRequired, validateEmailFormat } from '../../../common/hooks/useFormControls';

const requiredField = Validator(isRequired, 'This field is required');
const validEmail = Validator(validateEmailFormat, 'Please enter a valid email address');
const trimWhitespace = (value) => value.trim();

const billingContactForm = [
  {
    fieldName: 'billingContactName',
    label: 'Billing contact name',
    value: '',
    sanitizers: [trimWhitespace],
    validators: [requiredField],
  },
  {
    fieldName: 'billingContactEmail',
    label: 'Email address for billing messages',
    value: '',
    sanitizers: [trimWhitespace],
    validators: [requiredField, validEmail],
  },
];

export default billingContactForm;
